<template>
    <!-- 补充资料 -->
    <common-modal :isShowClose="isShowClose">
        <div class='supple-wrap'>
            <h1 class='title'>订单信息补充</h1>
            <div class="supple-text">
                <textarea placeholder="订单资料不全可以补充到这里哈,麻烦您~~" v-model='content'></textarea>
                <div class="upload">
                    <div class="img-title">上传图片（0/6）</div>
                    <imageUpload v-model='imgList'  :limit="6"/> 
                </div>
            </div>
            
            <div class="btn-wrap">
                <div class="cancel" @click='close'>取消</div>
                <div class="submit" @click="submit">确定</div>
            </div>
        </div>
    </common-modal>
</template>

<script>
    import commonModal from '@/components/commonModal.vue';
    import ImageUpload from '@/components/ImageUpload.vue';
    import {addSupplement} from '@/api/order.js';
export default {
    props:{
        isShowClose:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return{
            content:"",
            imgList:[],
            order_uuid:this.$route.query.order_uuid
        } 
    },

    methods: {
        close(){
            this.$emit("close")
        },
        
        async submit(){
            if(!this.content){
                this.$message("请输入内容");
                return
            }
            let parmas ={order_uuid:this.order_uuid,order_supplement:this.content,order_supplement_img:this.imgList}
            const { data, status } = await addSupplement(parmas);
            if (status !== 200) return ;
            this.$emit("submit");
            this.$message.success("信息补充成功");
        }
    },
    
    components:{
        commonModal,
        ImageUpload
    }
 } 
</script>

<style lang="scss" scoped>
    textarea::-webkit-input-placeholder{
        @include textarea-placeholder;
    }
    textarea::-moz-placeholder{   /* Mozilla Firefox 19+ */
        @include textarea-placeholder;
    }
    textarea:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
        @include textarea-placeholder;
    }
    textarea:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
        @include textarea-placeholder;
    }
    //补充资料
    .supple-wrap{
        padding: 30px;
        h1{
            text-align:center;
            @include font-style;
            font-size: 20px;
            color: #000000; 
        }
        .supple-text{
            box-sizing: border-box;
            padding: 30px 20px;
            background: #FFFFFF;
            textarea{
                width: 100%;
                box-sizing: border-box;
                resize: none;
                padding: 20px 0 0 20px;
                height: 150px;
                background: #F5F9FC;
            }
            .img-title{
                margin:20px 0
            }
			.upload{
				.dankal-image-upload{
					p{
						width: 150px;
						height: 150px;
						margin-right: 20px;
						margin-bottom: 10px;
					}
				}
			}
        }
        
        //弹框按钮
        .btn-wrap{
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            .submit{
                @include cursor-style;
                width: 80px;
                height: 36px;
                line-height: 36px;
                box-sizing: border-box;
                text-align: center;
                background: #FF8E1C;
                box-shadow: 1px 3px 6px 0px rgba(102, 102, 102, 0.16);
                border-radius: 5px;
                font-size: 15px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #FFFFFF;
            }
            .cancel{
                @include cursor-style;
                @extend .submit;
                font-weight: 400;
                background: #FFFFFF;
                border: 1px solid #9A9A9A;
                color: #9A9A9A;
                margin-right: 20px;
            }
            
        } 
    }
</style>
